module.exports = __webpack_public_path__ + "static/img/excel.96fa438.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icones/excel.png
// module id = lJd5
// module chunks = 1